module.exports = __webpack_public_path__ + "img/new_thread.8fdf80a2.svg";